import { useState, useEffect } from 'react';
import {
    Box,
    Heading,
    Text,
    Button,
    Flex,
    Badge,
    chakra,
    HStack,
    Link as ChakraLink
} from '@chakra-ui/react';
// Components
import { CustomDialog } from 'components/ui/dialog';
// Styles
import { benefitClubBannerStyles } from 'styles/homeStyles';

// Componente principal
export default function BenefitClubBanner() {
    const [isHovered, setIsHovered] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const handleConfirmDialog = () => {
        setOpenDialog(false);
        window.open("https://clube.aajump.com.br/", "_blank");
    };

    return (
        <Box {...benefitClubBannerStyles.mainBox}>
            {/* Elementos decorativos */}
            <Box {...benefitClubBannerStyles.decorativeBox1} />

            <Box {...benefitClubBannerStyles.decorativeBox2} />

            <Flex {...benefitClubBannerStyles.contentFlex}>
                {/* Ícone com animação */}
                <Box {...benefitClubBannerStyles.iconBox}>
                    <Flex {...benefitClubBannerStyles.iconFlex}>
                        🎁

                        {/* Efeitos de destaque ao redor do ícone */}
                        <Box {...benefitClubBannerStyles.iconEffect1} />

                        <Box {...benefitClubBannerStyles.iconEffect2} />
                    </Flex>
                </Box>

                {/* Badge de exclusivo */}
                <Badge {...benefitClubBannerStyles.exclusiveBadge}>
                    EXCLUSIVO
                </Badge>

                {/* Conteúdo textual */}
                <Heading as="h1" size={["xl", "3xl"]} {...benefitClubBannerStyles.mainHeading}>
                    <chakra.span {...benefitClubBannerStyles.headingSpan}>Clube de Benefícios</chakra.span>
                    <chakra.span {...benefitClubBannerStyles.subHeadingSpan}>
                        Experiências exclusivas para você
                    </chakra.span>
                </Heading>

                <Text {...benefitClubBannerStyles.descriptionText}>
                    São descontos, vantagens e experiências únicas em lojas, restaurantes e serviços parceiros por todo o Brasil. Vem fazer parte!
                </Text>

                {/* Características em destaque */}
                <HStack {...benefitClubBannerStyles.featureStack}>
                    {[
                        { text: "Descontos em parceiros", icon: "🛍️" },
                        { text: "Links e cupons exclusivos", icon: "🏷️" },
                        { text: "Vantagens em lojas físicas e online", icon: "🏪" }
                    ].map((item, index) => (
                        <Flex key={index} {...benefitClubBannerStyles.featureItem}>
                            <Box {...benefitClubBannerStyles.featureIcon}>{item.icon}</Box>
                            <Text {...benefitClubBannerStyles.featureText}>{item.text}</Text>
                        </Flex>
                    ))}
                </HStack>

                <Box {...benefitClubBannerStyles.containerButtons}>
                    {/* Botão CTA */}
                    <Button
                        size="lg"
                        {...benefitClubBannerStyles.ctaButton}
                        onClick={() => setOpenDialog(true)}
                        cursor="pointer"
                    >
                        Acessar Clube
                    </Button>

                    <ChakraLink
                        href="https://play.google.com/store/apps/details?id=br.com.redeparcerias.aajump"
                        target="_blank"
                        rel="noopener noreferrer"
                        referrerPolicy="no-referrer"
                        _hover={{ textDecoration: 'none' }}
                        style={{ textDecoration: 'none' }}
                    >
                        <Button
                            as="div"
                            size="lg"
                            {...benefitClubBannerStyles.googlePlayButton}
                        >
                            Baixe o app do clube
                        </Button>
                    </ChakraLink>
                </Box>

                {openDialog && (
                    <CustomDialog
                        open={openDialog}
                        titleBg="orange.500"
                        onClose={({ open }) => setOpenDialog(open)}
                        title="COMUNICADO IMPORTANTE"
                        body="A AAJUMP esclarece que tem formalizado alguns convênios com prestadores de serviços e/ou empresas com intuito de gerar benefícios para os seus associados. Porém, nossa associação não tem qualquer responsabilidade pela prestação de serviço ou aquisição de produtos dos conveniados, sendo a contratação de inteira responsabilidade do associado."
                        body2="Ao concordar, você será redirecionado para a nossa página de convênios chamada Clube de Benefícios."
                        onConfirm={handleConfirmDialog}
                        onCancel={() => setOpenDialog(false)}
                    />
                )}

                {/* Subtexto promocional */}
                <Text {...benefitClubBannerStyles.promoText}>
                    Aproveite agora os benefícios em centenas de parceiros pelo Brasil
                </Text>
            </Flex>
        </Box>
    );
}